import { supabase } from '@/lib/supabase';
import type { Category } from '@sharecost/shared';

export async function fetchCategories(): Promise<Category[]> {
  const { data, error } = await supabase
    .from('categories')
    .select('id, key, name, icon, color')
    .eq('_deleted', false)
    .order('name');

  if (error) throw error;
  return (data ?? []) as Category[];
}
